var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16V15H11C10.45 15 9.97933 14.8043 9.588 14.413C9.19667 14.0217 9.00067 13.5507 9 13V5H7V6C7 6.55 6.80433 7.021 6.413 7.413C6.02167 7.805 5.55067 8.00067 5 8H2C1.45 8 0.979333 7.80433 0.588 7.413C0.196667 7.02167 0.000666667 6.55067 0 6V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H5C5.55 0 6.021 0.196 6.413 0.588C6.805 0.98 7.00067 1.45067 7 2V3H13V2C13 1.45 13.196 0.979333 13.588 0.588C13.98 0.196667 14.4507 0.000666667 15 0H18C18.55 0 19.021 0.196 19.413 0.588C19.805 0.98 20.0007 1.45067 20 2V6C20 6.55 19.8043 7.021 19.413 7.413C19.0217 7.805 18.5507 8.00067 18 8H15C14.45 8 13.9793 7.80433 13.588 7.413C13.1967 7.02167 13.0007 6.55067 13 6V5H11V13H13V12C13 11.45 13.196 10.9793 13.588 10.588C13.98 10.1967 14.4507 10.0007 15 10H18C18.55 10 19.021 10.196 19.413 10.588C19.805 10.98 20.0007 11.4507 20 12V16C20 16.55 19.8043 17.021 19.413 17.413C19.0217 17.805 18.5507 18.0007 18 18H15C14.45 18 13.9793 17.8043 13.588 17.413C13.1967 17.0217 13.0007 16.5507 13 16ZM15 6H18V2H15V6ZM15 16H18V12H15V16ZM2 6H5V2H2V6Z",
    fill: "#F6764E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgTreeIcon);
export default __webpack_public_path__ + "static/media/orgTreeIcon.d4bf1bd586ea756d2ba7bd6da1cdf47e.svg";
export { ForwardRef as ReactComponent };